import { BRAND } from "@/lib/siteData";

export default function Welcome() {
  return (
    <section
      id="welcome"
      className="relative py-24 md:py-32 paper-grain"
      data-testid="welcome-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20 items-center">
        {/* Logo — left column */}
        <div className="md:col-span-5 flex justify-center md:justify-end">
          <img
            src={BRAND.emblemUrl}
            alt="Sri Bhavani Kalyana Mandira"
            className="h-48 md:h-72 lg:h-80 w-auto"
            data-testid="welcome-logo"
          />
        </div>

        {/* Content — right column */}
        <div className="md:col-span-7 text-center md:text-left">
          <p className="eyebrow" data-testid="welcome-overline">
            A Legacy of Hospitality
          </p>
          <h2
            className="mt-5 font-headings text-3xl md:text-5xl text-primary leading-tight"
            data-testid="welcome-heading"
          >
            A traditional Kalyana Mandira, rooted in Basavanagudi.
          </h2>

          <p
            className="mt-8 font-body text-lg md:text-xl leading-relaxed text-foreground/80"
            data-testid="welcome-paragraph"
          >
            For decades, Sri Bhavani Kalyana Mandira has stood as a preferred choice for families
            looking for a traditional marriage hall in Bengaluru. Nestled in the culturally rich
            neighbourhood of Basavanagudi, our venue beautifully combines classic charm with modern
            amenities — whether you are planning a grand South Indian wedding, an intimate
            engagement, or a sacred thread ceremony, we provide the perfect backdrop for your
            traditions to come alive.
          </p>
        </div>
      </div>
    </section>
  );
}
